import i1 from "assets/icons/i1.svg";
// import i2 from "assets/icons/i2.svg";
import i3 from "assets/icons/i3.svg";
// import i4 from "assets/icons/i4.svg";
import { FaAward, FaUserCheck } from "react-icons/fa";

const ChooseUs = () => {
  const list = [
    {
      isIcon: false,
      img: i1,
      title: "Highly Trained Security Professionals",
      style: "rb",
      text: "Our security personnel are rigorously trained to handle diverse security challenges. We ensure that every staff member is equipped with the knowledge and skills to provide vigilant protection for your property, assets, and loved ones.",
    },
    {
      isIcon: true,
      img: <FaUserCheck className="text-black text-4xl" />,
      style: "lb",
      title: "Efficient and Reliable Verification Process",
      text: "We understand the importance of trust in security services. That's why we conduct a thorough, yet efficient background verification process, providing fast and accurate results that meet your security needs.",
    },
    {
      isIcon: false,
      img: i3,
      title: "Cutting-Edge Security Technology",
      style: "tr",
      text: "Leverage the latest advancements in security technology with Noble Guard Security. Our state-of-the-art tools and systems enhance your protection and provide peace of mind, knowing you're always one step ahead of potential threats.",
    },
    {
      isIcon: true,
      img: <FaAward className="text-black text-4xl" />,
      style: "tl",
      title: "27+ Years of Proven Excellence",
      text: "With more than two decades of experience in security and verification services, we have built a solid reputation for delivering unparalleled accuracy and reliability across Nigeria.",
    },
  ];

  return (
    <div className="three bg-black" id="about">
      <div className="three-block">
        <p className="subtitle white pry-text">WHY CHOOSE US</p>
        <p className="header white pry-text center">
          Discover the <span className="ash">Noble Guard</span> Difference -
          Your
          <span className="ash"> Pathway</span> to{" "}
          <span className="ash">Unparalleled</span> Protection
        </p>
      </div>

      <div className="three-table">
        {list.map((item) => (
          <div className={`three-card bg-ash ${item.style}`} key={item.title}>
            {item.isIcon ? (
              <div className="shadow-lg mx-auto px-2 py-1.5 rounded-2xl bg-[rgba(255,255,255,0.93)] flex items-center justify-center">
                {item.img}
              </div>
            ) : (
              <img src={item.img} alt="" className="icon-svg" />
            )}
            <p className="title pry-text center white">{item.title}</p>
            <p className="pry-text white center list shift-up">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseUs;
